import * as React from 'react';
import { observer } from 'mobx-react-lite';
import type { PluginUIProps } from 'owa-editor/lib/store/schema/PluginWithUI';
import { ComposeFeedback } from 'owa-compose-feedback';
import type AugLoopViewState from '../store/schema/AugLoopViewState';
import TeachingBubbleCallout from './TeachingBubbleCallout';

export default observer(function AugLoopPluginUI(props: PluginUIProps<AugLoopViewState>) {
    const {
        feedbackRibbonDetails,
        shouldShowFeedbackRibbon,
        isFeedbackProvided,
    } = props.viewState.composeFeedbackViewState;
    const sonoraViewState = props.viewState.sonoraViewState;
    return (
        <>
            <ComposeFeedback
                feedbackRibbonDetails={feedbackRibbonDetails}
                shouldShowFeedbackRibbon={shouldShowFeedbackRibbon}
                isFeedbackProvided={isFeedbackProvided}
            />
            {sonoraViewState && (
                <TeachingBubbleCallout
                    shouldShow={sonoraViewState.shouldShowTeachingBubble}
                    target={sonoraViewState.teachingBubbleTarget}
                    text={sonoraViewState.teachingBubbleText}
                />
            )}
        </>
    );
});
